<template>
    <div id="app">
        <router-view />
        <loading-view v-bind:show="show"></loading-view>
    </div>
</template>

<script>
    import Loading from '@/components/item/Loading';

    export default {
        name: 'App',
        components: {
            'loading-view': Loading
        },
        data() {
            return {
                show: false,
                meta: {}
            };
        },
        beforeCreate() {
            this.$store.dispatch('setProfile', {requestOptions: {meta: {throwError: false}}});
            this.axios.interceptors.request.use(
                    request => {
                        this.meta = request.meta || {};
                        this.show = typeof this.meta.loading !== typeof undefined ? this.meta.loading : true;
                        return request;
                    }
            );
            this.axios.interceptors.response.use(
                    response => {
                        this.show = false;
                        return response;
                    },
                    error => {
                        this.show = false;

                        var throwError = typeof this.meta.throwError !== typeof undefined ? this.meta.throwError : true;
                        if (throwError) {
                            switch (error.response.status) {
                                case 401:
                                    this.$toastr('warning', error.response.statusText, 'Warning');
                                    this.$router.replace({name: 'authenticate/login'});
                                    break;
                                default:
                                    this.$router.push({name: 'error', params: {code: error.response.status, message: error.response.statusText}});
                                    break;
                            }
                        }
                        return error;
                    }
            );
        },
        mounted() {
            if (document.title === '') {
                document.title = process.env.APP_NAME;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue